import { useSelector } from 'react-redux'
import BRAND from './config'
import { API_URL, BASE_URL } from '../config/constants'
import { IS_NATIVE } from '../services/auth/nativeAuth'
import tf_logo from '../assets/images/logo_tf.svg'

export default BRAND

// brand logo, else the tenant one, else thefaculty
export const useLogo = () => {
    const logoUrl = useSelector(state => state.appInfo.personalizations?.logo_url)
    return BRAND.logo || (logoUrl ? `${API_URL}${logoUrl}` : tf_logo)
}

// tab title, favicon, home screen icon and PWA manifest: the brand ones, else the tenant ones
export const setWebAppIdentity = (personalizations) => {
    const name = BRAND.appName || personalizations?.app_name || 'thefaculty Business'
    const icon = new URL(BRAND.icon || (personalizations?.logo_icon_url ? `${API_URL}${personalizations.logo_icon_url}` : '/static/favicon_blue.png'), window.location.href).href
    const color = personalizations?.background?.color || '#ffffff'
    const manifest = {
        name,
        short_name: BRAND.appName || personalizations?.app_short_name || name,
        start_url: BASE_URL,
        background_color: color,
        theme_color: color,
        display: 'standalone',
        icons: [{ src: icon, sizes: BRAND.icon ? '1024x1024' : '256x256', type: 'image/png' }],
    }
    document.title = name
    document.querySelector('#icon-placeholder').href = icon
    document.querySelector('#apple-icon-placeholder').href = icon
    // not in the native app: nothing to install there, and its theme_color would keep the iOS app full screen
    if (!IS_NATIVE)
        document.querySelector('#manifest-placeholder').href = URL.createObjectURL(new Blob([JSON.stringify(manifest)], { type: 'application/json' }))
}
